import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7859637b")

_pushScopeId("data-v-7859637b")
const _hoisted_1 = { class: "news-page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-stretch" }
const _hoisted_4 = { class: "news__img" }
const _hoisted_5 = { class: "news__date" }
const _hoisted_6 = { class: "news__title" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BreadCrumbs = _resolveComponent("BreadCrumbs")
  const _component_SectionTitle = _resolveComponent("SectionTitle")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_BreadCrumbs, { links: [{ to: 'news', name: 'adaptiveTop.articles' }] }),
      _createVNode(_component_SectionTitle, {
        title: _ctx.$t('pages.news.title1'),
        class: "news-page__title"
      }, null, 8, ["title"]),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.news, (newsItem) => {
          return (_openBlock(), _createBlock("div", {
            key: newsItem.id,
            class: "col-12 col-md-6 col-lg-4 col-xl-3"
          }, [
            _createVNode(_component_router_link, {
              class: "news",
              to: {
            name: 'singlenews',
            params: { newsId: newsItem.id }
          }
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_4, [
                  _createVNode("img", {
                    src: _ctx.getFile(newsItem.image),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('labels.fromTourstat', [' | ' + newsItem.created_at])), 1),
                _createVNode("div", _hoisted_6, _toDisplayString(newsItem.title), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
})